<template>
	<a class="nk-help" v-if="helpURL.length" :href="helpURL" target="_blank">
		<i class="fas fa-play"></i>
	</a>
</template>

<script>
	export default {
		props: {
			helpURL: { type: String, default: '' }
		}
	}
</script>

<style></style>